import localAxios from '../../localAxios';
import { workspaceQuizURL } from '../workspacesURLs';

interface WorkspaceQuizParams {
  workspaceId: string;
  workspaceQuizId: string;
}

type Image = {
  id: number;
  url: string;
  type: string;
  data?: any;
  urlXS: string;
  urlS: string;
  urlM: string;
  urlL: string;
  urlXL: string;
};

type Answer = {
  id: number;
  created_by_id: number;
  text: string;
  isCorrect: boolean;
  order: number;
  questionId: number;
  legacyId?: any;
  image: Image;
};

type Question = {
  questionId: number;
  type: string;
  createdById: number;
  order: number;
  questionText: string;
  explanation: string;
  createdDate: string;
  gradingWeight: number;
  quizId: number;
  legacyId?: any;
  answers: Array<Answer>;
  questionImage: Image;
  explanationImage: Image;
};

type Quiz = {
  id: number;
  sharable: boolean;
  isHidden: boolean;
  createdDate: string;
  name: string;
  lastUpdated: string;
  socNumber: string;
  questions: Array<Question>;
  version: number;
};

export interface WorkspaceQuizResponse {
  id: string;
  workspaceId: string;
  lockId: string;
  publishedBy: string;
  parentFolderId: string;
  publishedDate: string;
  owner: string;
  deletedDate: null;
  type: 'quiz';
  versionId: string;
  quiz: Quiz;
}

export async function getWorkspaceQuiz({
  workspaceId,
  workspaceQuizId,
}: WorkspaceQuizParams) {
  const url = workspaceQuizURL({ workspaceQuizId, workspaceId });
  const response = await localAxios.get<WorkspaceQuizResponse>(url.href);
  return response.data;
}
